import React from 'react';

import './Style/style.scss';
import HomePage from './Pages/HomePage';
import ColumbusPage from './Pages/ColumbusPage';
import ObrotPage from './Pages/ObrotPage';
// import CspPage from './Pages/CspPage';
import GoBiznesPage from './Pages/GoBiznesPage';
import AgentsPage from './Pages/AgentsPage';
import HRPage from './Pages/HRPage';
import OnePage from './Pages/OnePage';
import ZeneraPage from './Pages/ZeneraPage';
import PrimePage from './Pages/PrimePage';

import {
  HashRouter,
  Routes,
  Route,
} from "react-router-dom";


import { Provider } from 'react-redux';
import rootReducer from './store/reducers';
import { createStore } from 'redux';
let store = createStore(rootReducer);

// import { configureStore } from 'redux';
// let store = configureStore({ reducer: rootReducer })

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <HashRouter>
          <Routes>
            {/* The default route */}
            <Route path="/" element={
              <HomePage />
            }/>
            <Route path="hello" element={
              <HomePage />
            }/>
            <Route path="columbus" element={
              <ColumbusPage/>
            }/>
            <Route path="columbus-dla-biznesu" element={
              <GoBiznesPage />
            }/>
            <Route path="columbus-obrot" element={
              <ObrotPage />
            }/>
            <Route path="siec-agencyjna" element={
              <AgentsPage />
            }/>
            <Route path="hr" element={
              <HRPage />
            }/>
            <Route path="one" element={
              <OnePage />
            }/>
            <Route path="zenera" element={
              <ZeneraPage />
            }/>
            <Route path="prime" element={
              <PrimePage />
            }/>
            {/* <Route path="sieci-partnerskie" element={
              <CspPage />
            }/> */}
          </Routes>
        </HashRouter>
      </div>
    </Provider>
  )
}

export default App;